// src/services/activity.service.js
import { api } from './api';

class ActivityService {
    /**
     * Get recent activities
     */
    async getRecentActivities(limit = 10) {
        try {
            const response = await api.get(`/api/activities/recent?limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching recent activities:', error);
            throw error;
        }
    }

    /**
     * Get upcoming activities
     */
    async getUpcomingActivities(days = 7, limit = 20) {
        try {
            const response = await api.get(`/api/activities/upcoming?days=${days}&limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching upcoming activities:', error);
            throw error;
        }
    }

    /**
     * Get all activities with filters
     */
    async getAllActivities(filters = {}) {
        try {
            const params = new URLSearchParams();
            if (filters.status) params.append('status', filters.status);
            if (filters.type) params.append('type', filters.type);

            const response = await api.get(`/api/activities?${params.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching activities:', error);
            throw error;
        }
    }

    /**
     * Create new activity
     */
    async createActivity(activityData) {
        try {
            const response = await api.post('/api/activities', activityData);
            return response.data;
        } catch (error) {
            console.error('Error creating activity:', error);
            throw error;
        }
    }

    /**
     * Update activity
     */
    async updateActivity(activityId, activityData) {
        try {
            const response = await api.put(`/api/activities/${activityId}`, activityData);
            return response.data;
        } catch (error) {
            console.error('Error updating activity:', error);
            throw error;
        }
    }

    /**
     * Delete activity
     */
    async deleteActivity(activityId) {
        try {
            const response = await api.delete(`/api/activities/${activityId}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting activity:', error);
            throw error;
        }
    }

    /**
     * Complete activity
     */
    async completeActivity(activityId) {
        try {
            const response = await api.put(`/api/activities/${activityId}/complete`);
            return response.data;
        } catch (error) {
            console.error('Error completing activity:', error);
            throw error;
        }
    }

    /**
     * Cancel activity
     */
    async cancelActivity(activityId) {
        try {
            const response = await api.put(`/api/activities/${activityId}/cancel`);
            return response.data;
        } catch (error) {
            console.error('Error cancelling activity:', error);
            throw error;
        }
    }
}

export default new ActivityService();
